import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_uyrp83b3tq: FaireBrandEntity = {
  token: "b_uyrp83b3tq",
  type: "brand",
  name: "Soleinspire",
  avatarUrl:
    "https://cdn.faire.com/fastly/70ded9123fa216fb292e9ec8091ab3553fd739c76dfd84c3cc68ee7e5c95461a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0bb8edb693cbd456cc6cd93fe8025727c228c11e2a6ccc1d95a487c06cdaa4e2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/70ded9123fa216fb292e9ec8091ab3553fd739c76dfd84c3cc68ee7e5c95461a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0bb8edb693cbd456cc6cd93fe8025727c228c11e2a6ccc1d95a487c06cdaa4e2.jpeg",
  location: "Goode, VA, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "At SoleInspire, we believe every graphic tells a story—and every story deserves to be worn with pride. What started as a passion for bold self-expression through design has grown into a reliable wholesale partner for retailers who seek quality, originality, and meaning behind every print.\n\nFounded with the mission to blend art, culture, and comfort, SoleInspire curates a collection of premium graphic tees that resonate with modern consumers—whether they're driven by humor, hope, rebellion, or raw creativity. Each piece is printed on ethically sourced, ultra-soft cotton and crafted to move with the times, while staying rooted in authenticity.\n\nWe don’t just sell shirts—we empower small businesses, boutiques, and eCommerce brands with fast-moving, retail-ready designs that convert. From empowering quotes to viral aesthetics, our catalog is constantly evolving to reflect what people love, talk about, and wear.\n\nOur commitment is simple: reliable wholesale service, trend-forward graphics, and a shared goal—to inspire, one shirt at a time. Partner with SoleInspire and let your shelves speak louder than words.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:51.311Z",
    importedBy: "entity-db-cli",
  },
};
